import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  IconButton,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import api from "./api/apiClient";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ManualAllocateToFeTl = () => {
  const navigate = useNavigate();
  const [unallocatedChecks, setUnallocatedChecks] = useState([]);
  const [allocatedChecks, setAllocatedChecks] = useState([]);
  const [selectedCheckIds, setSelectedCheckIds] = useState([]);
  const [selectedChecks, setSelectedChecks] = useState([]);
  const [tlList, setTlList] = useState([]);
  const [selectedTl, setSelectedTl] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetchAddressChecks();
    fetchTeamLeads();
  }, [allocatedChecks]);

  const getFeTlName = (tlId)=>{
    console.log("Name required for tlId ",tlId);
    for(let i=0; i < tlList.length;i++){
      let item = tlList[i];
      if(item.id === tlId){
        console.log("Returning name ",item.name);
        return item.name;
      }      
    }

  }
  const fetchAddressChecks = async () => {
    try {
/*      const unallocatedRes = await api.get("/addresscheckone/unallocated");
      const allocatedRes = await api.get("/addresscheckone/allocated");
      setUnallocatedChecks(unallocatedRes.data);
      setAllocatedChecks(allocatedRes.data);*/
      let response = await api.get(`/addresscheckones/casestoallocatetofetl`);
      let allocated = []
      let unallocated = []
      response.data.forEach(check=>{
          if(check.allocatedToFeTl == null){
            unallocated.push(check);
          }else{
            allocated.push(check)
          }
      })
      setUnallocatedChecks(unallocated);
      setAllocatedChecks(allocated);
      console.log("Checks to allocate ",response.data);
    } catch (error) {
      console.error("Error fetching address checks", error);
    }
  };

  const fetchTeamLeads = async () => {
    try {
      const response = await api.get("/users/fetls");
      setTlList(response.data);
    } catch (error) {
      console.error("Error fetching TL list", error);
    }
  };

  const handleCheckToggle = (check) => {
    const key = getUniqueCheckKey(check);
    setSelectedChecks((prev) => {
      const exists = prev.find((c) => getUniqueCheckKey(c) === key);
      return exists
        ? prev.filter((c) => getUniqueCheckKey(c) !== key)
        : [...prev, check];
    });
  };
  

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setSelectedCheckIds([]); // Clear selection on tab switch
  };
  const getUniqueCheckKey = (check) =>
  `${check.caseId}__${check.checkType}__${check.checkId}`;


  const renderTable = (data, showAllocatedTo = false, showCheckbox = false) => (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: 400, overflow: "auto" }} // <- Add this line
    >
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            {showCheckbox && <TableCell />}
            <TableCell>Case ID</TableCell>
            <TableCell>Check Type</TableCell>
            <TableCell>Check ID</TableCell>
            <TableCell>Candidate Name</TableCell>
            <TableCell>Address</TableCell>
            <TableCell>City</TableCell>
            <TableCell>PIN</TableCell>
            <TableCell>Status</TableCell>
            {showAllocatedTo && <TableCell>Allocated To</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((check) => (
            <TableRow key={getUniqueCheckKey(check)} hover>
              {showCheckbox && (
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedChecks.some((c) => getUniqueCheckKey(c) === getUniqueCheckKey(check))}
                    onChange={() => handleCheckToggle(check)}
                  />
                </TableCell>
              )}
              <TableCell>{check.caseId}</TableCell>
              <TableCell>{check.checkType}</TableCell>
              <TableCell>{check.checkId}</TableCell>
              <TableCell>{check.candidateName}</TableCell>
              <TableCell>{check.address}</TableCell>
              <TableCell>{check.city}</TableCell>
              <TableCell>{check.pin}</TableCell>
              <TableCell>{check.status}</TableCell>
              {showAllocatedTo && <TableCell>{getFeTlName(check.allocatedToFeTl)}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  

  const isButtonDisabled = selectedChecks.length === 0 || !selectedTl;

  const handleAllocateChecks = async()=>{
    console.log("Allocate:", selectedChecks, "to TL:", selectedTl);
    try{
      let response = api.put(`/addresscheckones/assigntofetl/${selectedTl}`,selectedChecks);
      fetchAddressChecks();
      setSelectedChecks([]); 
    } catch(error){
      console.log("Error allocating checks",error);
    }  
  }
  const handleBack = () => {
    navigate(-1); // Navigate to previous screen
  };
  return (
    <Box sx={{ width: "95%", margin: "auto", mt: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ ml: 1 }}>
          Manual Allocation To TL
        </Typography>
      </Box>
{/*      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Unallocated" />
        <Tab label="Allocated" />
  </Tabs>*/}
      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label={`Unallocated${unallocatedChecks.length > 0 ? ` (${unallocatedChecks.length})` : ''}`} />
        <Tab label={`Allocated${allocatedChecks.length > 0 ? ` (${allocatedChecks.length})` : ''}`} />
      </Tabs>


      {tabIndex === 0 && renderTable(unallocatedChecks, false, true)}
      {tabIndex === 1 && renderTable(allocatedChecks, true, true)}

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="tl-select-label">Select TL</InputLabel>
          <Select
            labelId="tl-select-label"
            value={selectedTl}
            label="Select TL"
            onChange={(e) => setSelectedTl(e.target.value)}
          >
            {tlList.map((tl) => (
              <MenuItem key={tl.id} value={tl.id}>
                {tl.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {tabIndex === 0 && (
          <Button
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
            onClick={handleAllocateChecks}
          >
            Allocate
          </Button>
        )}

        {tabIndex === 1 && (
          <Button
            variant="contained"
            color="secondary"
            disabled={isButtonDisabled}
            onClick={() => {
              console.log("Re-Allocate:", selectedCheckIds, "to TL:", selectedTl);
              // Add your API call for re-allocation here
            }}
          >
            Re-Allocate
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ManualAllocateToFeTl;
